import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class ConfirmationModalComponent {
  constructor(private modalService: BsModalService) {}
  @Input() commonEnum: { NO: string; YES: string };
  @Input() ConfirmationMessage: string;
  @Input() headerLabel: string;
  @Input() isDeleteModal: boolean = true;
  @Input() dynamicClass: string = '' ;


  @Output() confirmDelete = new EventEmitter<void>();
  @Output() cancelDelete = new EventEmitter<void>();
  
  @ViewChild('customModalTemplate', { static: true })
  customModalTemplate: TemplateRef<any>;
  modalRef: BsModalRef;

  openModal() {
    this.modalRef = this.modalService.show(this.customModalTemplate);
  }

  closeModal() {
    this.modalRef.hide();
  }

  onConfirm() {
    this.confirmDelete.emit();
    this.closeModal();
  }

  onCancel() {
    this.cancelDelete.emit();
    this.closeModal();
  }
}
